import React from 'react';
import styled from 'styled-components';
import NavLink from 'TMComponents/NavLink';
import Facebook from 'TMComponents/Icons/Facebook';
import Youtube from 'TMComponents/Icons/Youtube';
import Instagram from 'TMComponents/Icons/Instagram';
import { string, oneOf } from 'prop-types';

const Link = styled(NavLink)`
    margin-left: -8px;
`;

const SocialMediaLink = ({ link, company, size = 'md' }) => {
    const iconMap = {
        instagram: Instagram,
        facebook: Facebook,
        youtube: Youtube
    };

    const Icon = iconMap[company];
    if (!Icon) {
        return null;
    }
    return (
        <Link href={link}>
            <Icon width={size === 'lg' ? 68 : 56} />
        </Link>
    );
};
SocialMediaLink.propTypes = {
    link: string.isRequired,
    company: string.isRequired,
    size: oneOf(['md', 'lg'])
};

export default SocialMediaLink;
